import React from 'react';
import GroupsIcon from '@mui/icons-material/Groups';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

import styles from './MaxAnswersMessage.module.css';

/**
 * Mensaje que se muestra cuando la encuesta ya alcanzó el máximo de respuestas
 * configurado en Survey.MaxAnswer. Reemplaza a los mensajes genéricos de
 * "ya respondida" / "no disponible", que no explican la causa real.
 *
 * @returns {JSX.Element}
 * @constructor
 */
const MaxAnswersMessage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div className={styles.ErrorMessage}>
      <GroupsIcon style={{ fontSize: 200, color: 'orange' }} />

      <Typography variant={isMobile ? 'h5' : 'h4'} gutterBottom>
        Esta encuesta ya alcanzó el número máximo de respuestas.
      </Typography>

      <Typography variant="h5" gutterBottom style={{ fontStyle: 'italic' }}>
        Gracias por tu interés.
      </Typography>
    </div>
  );
};

MaxAnswersMessage.propTypes = {};

MaxAnswersMessage.defaultProps = {};

export default MaxAnswersMessage;
